import { Routes } from '@angular/router';

export const visitSummaryRoutes: Routes = [
  {
    path: 'summary',
    loadComponent: () =>
      import('./subscription-activation/subscription-activation.component').then(
        (m) => m.SubscriptionActivationComponent,
      ),
  },
  {
    path: 'failed-payment',
    loadComponent: () =>
      import('./subscription-activation-failed-payment/subscription-activation-failed-payment.page').then(
        (m) => m.SubscriptionActivationFailedPaymentPage,
      ),
    data: {
      background: 'assets/splash_bck.png',
      shouldShowTabBar: false,
    },
  },

  {
    path: 'confirmation',
    loadComponent: () =>
      import('./subscription-confirmation/subscription-confirmation.component').then(
        (m) => m.SubscriptionConfirmationComponent,
      ),
  },
  {
    path: 'schedule',
    loadComponent: () =>
      import('./schedule-consultation/schedule-consultation.page').then((m) => m.ScheduleConsultationPage),
  },
  {
    path: 'schedule-confirmation',
    loadComponent: () =>
      import('../../shared/pages/flow-schedule-confirmation/flow-schedule-confirmation.page').then(
        (m) => m.FlowScheduleConfirmationPage,
      ),
    data: { flowType: 'visitSummary' },
  },
];
